<div class="rating" [ngClass]="design" [formGroup]="ratingForm">
    <ng-container *ngFor="let star of getStars()?.controls; index as i">
        <input type="radio" class="rating__input" id="{{random + i}}" [checked]="star.value" (click)="changeRating(i)">
    </ng-container>
    <ng-container *ngFor="let star of getStars()?.controls; index as i">
        <label for="{{random + i}}" class="rating__star">
            <app-icons design="icon-star-filled"></app-icons>
        </label>
    </ng-container>
</div>